import Entidade from '../constants/Entidade';

const envVars = {};

// Capturar variáveis ENV (arquivo .env) e remover prefixo REACT_APP
// https://create-react-app.dev/docs/adding-custom-environment-variables/
for (const envAttr in process.env) {
  if (envAttr.startsWith('REACT_APP_')) {
    envVars[envAttr.substr(10)] = process.env[envAttr];
  }
}

const config = {
  appKey: '@egresso',
  urlSiteUnyleya: 'https://unyleya.edu.br',
  entidadeTextosSistema: Entidade.FACULDADE_UNYLEYA,
  ...envVars,
};

export default config;
